document.addEventListener("DOMContentLoaded", function () {
  const sliderElements = document.querySelectorAll(".splide.image-with-text__custom"); 
  
  function initSplide() {
    sliderElements.forEach((sliderElement) => {
      let splideInstance; 
      if (splideInstance) {
        splideInstance.destroy(true);
        splideInstance = null;
      }

        const instance = new Splide(sliderElement, {
          type: "slide",
          rewind: true,
          perPage: 1,
          focus: "center",
          pagination: true,
          arrows: false,
        }).mount();
      
    });
  }

  initSplide();
});

